<template>
  <div class="time-buttons">
    <b-button
      v-for="button in buttons"
      :key="button.value"
      variant="link"
      class="time-buttons__button"
      :class="{ active: activeTimeButton === button.value }"
      @click="setActiveTimeView(button.value)"
    >
      {{ button.label }}
    </b-button>
  </div>
</template>

<script>
import MomentTimezone from 'moment-timezone';
import { FORMAT_YMD } from '@/components/shared/date-format';
import { BUTTONS_NAMES } from '@/components/shared/visnet-hubs-common-consts';

export default {
  name: 'TimeButtons',
  props: {
    activeTimeButton: Number
  },
  data() {
    return {
      buttons: BUTTONS_NAMES
    };
  },
  methods: {
    setActiveTimeView(buttonValue) {
      this.$emit('change', buttonValue);
    },
    today() {
      return MomentTimezone().format(FORMAT_YMD);
    }
  }
};
</script>
